<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaOrase')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaJudet')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                                <i class="fas fa-search"></i>
                            </span>
                    </div>
                    <button type="button" v-if="$can(['create city'])" class="template-button" @click="$router.push('/cities/create')">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaOras')}}
                    </button>
                </div>
            </div>
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}} "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
           <div class="mobile-sort-by">
                <v-select :options="this.mobileSorting"
                          v-model="sortMobile.sortMobileBy"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name" placeholder="Sorteaza dupa:">
                 </v-select>
           </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType"
                          v-model="sortMobile.sortMobileType"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name"
                          placeholder="Criteriu sortare:">
                </v-select>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('county')"> {{$t('tableHeader.judet')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'county' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'county' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th scope="col" @click="handleSort('city')"> {{$t('tableHeader.oras')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'city' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'city' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="cities">
                <tr v-for="(second, index) in cities" :key="index">
                    <td :tableheadData="$t('tableHeader.judet')"> {{(second.county) ? second.county: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.oras')"> {{(second.name) ? second.name: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.denumire')" class="options-case">
                        <router-link :to="{ name: 'editcity', params: { id: second.id }}" class="edit-user" v-if="$can(['update city'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['delete city'])"
                           :title="$t('placeholder.sterge')" @click="removeCities(index, second.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="3" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="3" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="cities">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.judet')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.oras')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="cities">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import CitiesService from '../../api-services/cities.service.js'
export default {
  name: 'cities',
  data () {
    return {
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      mobileSorting: [
        { key: 'city', name: 'City' },
        { key: 'county', name: 'County' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      cities: null,
      filters: {
        per_page: 25
      },
      search: '',
      searchBy: this.$route.query.q || null,
      meta: {}
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getCities()
    }
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.key : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },
    // return second page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return this.meta.current_page - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return this.meta.current_page + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    getCities () {
      this.cities = null
      this.$store.dispatch('showLoading')
      CitiesService.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.cities = response.data.data
          } else {
            this.cities = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'cities', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    removeCities (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeOras'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          CitiesService.delete(id)
            .then((response) => {
              this.$delete(this.cities, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.mobileSorting.find(function (element) {
            return element.key === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    }
  },
  created () {
    let query = this.$route.query
    if (query.q) this.search = query.q
    this.getCities()
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
  }
}
</script>
